import {reason} from '../../reason.js';

export const metricsDomainUri = 'metrics';

export const metricsFailure = `${metricsDomainUri}.errors.failure`;
export const metricsUnhandledMessage = `${metricsDomainUri}.errors.unhandled_message`;
export const metricsBadIdentity = `${metricsDomainUri}.errors.bad_identity`;
export const reasonPeerRemoved = reason(`${metricsDomainUri}.peer-removed`, 'Peer has been removed');
